import { Droplets } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { Link } from "react-router-dom";

export const Footer = ({ settings }) => {
  const { t } = useLang();
  const instagramUrl = settings?.instagram_url || "https://www.instagram.com/purple_ink_studio/";

  return (
    <footer className="border-t border-white/5 py-12 px-6" data-testid="footer">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <Droplets className="w-5 h-5 text-purple-500" />
          <span
            className="text-sm font-bold tracking-[0.15em] uppercase text-neutral-400"
            style={{ fontFamily: "'Cinzel Decorative', serif" }}
          >
            Purple INK
          </span>
        </div>
        <p className="text-xs text-neutral-600">
          &copy; {new Date().getFullYear()} Purple INK Tattoo Studio. {t("footer_rights")}
        </p>
        <div className="flex gap-6">
          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-neutral-500 hover:text-purple-400 transition-colors duration-200 tracking-wider uppercase"
            data-testid="footer-instagram"
          >
            Instagram
          </a>
          <a
            href="#contact"
            className="text-xs text-neutral-500 hover:text-purple-400 transition-colors duration-200 tracking-wider uppercase"
            data-testid="footer-contact"
          >
            {t("nav_contact")}
          </a>
          <Link
            to="/cookie-policy"
            className="text-xs text-neutral-600 hover:text-purple-400 transition-colors duration-200 tracking-wider"
            data-testid="footer-cookie-policy"
          >
            {t("cookie_policy_link")}
          </Link>
        </div>
      </div>
    </footer>
  );
};
